export default "__VITE_ASSET__BBmd$WlK__"